/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

// storageUtils.js
export function setTenantId(value) {
    sessionStorage.setItem('tenantId', value);
    window.dispatchEvent(new Event('TenantIdUpdate'));
  }
  
  export function clearRealmId() {
      sessionStorage.removeItem('tenantId');
      window.dispatchEvent(new Event('TenantIdUpdate'));
  }
  